import React, { useState, useRef, useEffect } from "react";

interface CropCenterProps {
	width: number;
	height: number;
	viewbox: string;
	children: React.ReactNode;
}

const CropCenter: React.FC<CropCenterProps> = ({
	width,
	height,
	viewbox,
	children
}) => {
	// return <img src="../footerContour.svg" alt="contour map " />;
	const svgRef = useRef<SVGSVGElement>(null);
	const [viewBox, setViewBox] = useState<string>(viewbox);

	//Define a Singelton
	const initialValuesRef = useRef<{
		initialX: number;
		initialY: number;
		initialWidth: number;
		initialHeight: number;
		initialCenterX: number;
	}>();

	// Set up the initial values only once
	useEffect(() => {
		const initialVals = viewBox.split(" ").map(parseFloat);

		initialValuesRef.current = {
			initialX: initialVals[0],
			initialY: initialVals[1],
			initialWidth: initialVals[2],
			initialHeight: initialVals[3],
			initialCenterX: initialVals[0] + initialVals[2] / 2
		};

		//Prime the Centering process
		recenterSvg();

		// eslint-disable-next-line
	}, []); // Empty dependency array ensures this runs only once on mount

	// Effect to handle window resize
	const recenterSvg = () => {
		if (!svgRef.current || !initialValuesRef.current) return;

		const { initialCenterX, initialY, initialWidth, initialHeight } =
			initialValuesRef.current;

		const newWidth = window.innerWidth;
		const middlePoint = initialCenterX - newWidth / 2;
		const newX = Math.max(0, middlePoint);

		// Update the viewBox through React state
		setViewBox(`${newX} ${initialY} ${initialWidth} ${initialHeight}`);
	};

	// Effect to handle window resize
	useEffect(() => {
		window.addEventListener("resize", recenterSvg);

		// Cleanup
		return () => {
			window.removeEventListener("resize", recenterSvg);
		};

		// eslint-disable-next-line
	}, []); // Empty dependency array - we don't want to recreate this effect

	return (
		<svg
			ref={svgRef}
			width={width}
			height={height}
			viewBox={viewBox}
			className="text-primary-inactive"
			overflow="hidden"
		>
			{children}
		</svg>
	);
};

export default CropCenter;
